import React from 'react';
import { FormProvider } from 'react-hook-form';

//USING STEP FROM PRODUCT CREATION DIALOG
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import { ProductInformation } from '../../../../types/Products/product';
import { useProductEditor } from '../../../../services/Products/hooks/useProductEditor';

export default function EditProductDialog({
  initialFormState,
}: {
  initialFormState: Partial<ProductInformation>;
}) {
  const {
    methods,
    currentStep,
    onImageRemoval,
    handleStepOneSubmission,
    handleStepTwoSubmission,
  } = useProductEditor(initialFormState);
  if (currentStep > 1) return null;

  return (
    <FormProvider {...methods}>
      <form>
        {currentStep == 0 && <StepOne onNext={handleStepOneSubmission} />}
        {currentStep == 1 && (
          <StepTwo
            onNext={handleStepTwoSubmission}
            onImageRemoval={onImageRemoval}
          />
        )}
      </form>
    </FormProvider>
  );
}
